import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "onboarding-statements__text" }
const _hoisted_2 = { class: "onboarding-statements__controls" }

import { computed, onMounted, ref } from 'vue'

import { QuestionnaireView } from '@/models/onboarding'
import { StatementsChoice, StatementsPage } from '@/models/onboarding.types'
import { PublicInterface } from '@/models/interfaces'

import Layout from '../Layout.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Statements',
  props: {
    view: {}
  },
  setup(__props: any) {

const props = __props

onMounted(() => {
  // The default value of `view.currentChoice` is `undefined`.
  // The value of the choices for this page is an array, so
  // we set the initial value of `view.currentChoice` to an
  // empty array so that we can spread the current value
  // without having to check if it's an array first.
  props.view.setCurrentChoice([])
})

const page = computed(() => {
  return props.view.currentPage as StatementsPage
})

const currentChoice = computed(() => {
  return props.view.currentChoice as StatementsChoice
})

const currentStatementIndex = computed(() => {
  return props.view.currentSubpageIndex
})

const currentStatement = computed(() => {
  return page.value.content[currentStatementIndex.value]
})

const colors = ['255, 147, 88', '56, 118, 240', '81, 176, 111']

/**
 * This ref is used to trigger the <Transition> component
 * that animates the transition between cards. The actual
 * value of this ref is irrelevant, we just need to change
 * it to trigger the animation.
 */
const triggerTransitionAnimation = ref(false)

/**
 * The direction of the card swipe animation
 * when going to the next card. This value
 * is used in the CSS transitions.
 *
 * -1 = right
 * +1 = left
 */
const cssSwipeDirection = ref<-1 | 1>(1)

function nextStatement(liked: boolean): void {
  if (liked) {
    props.view.setCurrentChoice([
      ...currentChoice.value,
      currentStatement.value,
    ])

    cssSwipeDirection.value = 1
  } else {
    cssSwipeDirection.value = -1
  }

  const nextStatementExists = props.view.nextSubpage()

  if (!nextStatementExists) {
    setTimeout(() => {
      // This timeout moves this action to the end
      // of the event queue, giving time to finish
      // the swipe animation of the last card.
      props.view.nextPage()
    }, 0)
  }

  triggerTransitionAnimation.value = !triggerTransitionAnimation.value
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Layout, {
    class: "onboarding-statements",
    title: page.value.title,
    subtitle: page.value.subtitle,
    style: _normalizeStyle({
      '--swipe-direction': cssSwipeDirection.value,
    })
  }, {
    default: _withCtx(() => [
      _createVNode(_Transition, {
        name: "slide",
        mode: "out-in"
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock("div", {
            key: `${triggerTransitionAnimation.value}`,
            class: "onboarding-statements__cards-wrapper"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(page.value.content, (statement, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: _normalizeClass(["onboarding-statements__card", {
            'onboarding-statements__card--prev': index < currentStatementIndex.value,
            'onboarding-statements__card--current':
              index === currentStatementIndex.value,
            'onboarding-statements__card--next': index > currentStatementIndex.value,
          }]),
                style: _normalizeStyle({
            '--background-color': colors[index % colors.length],
            '--statement-index': index - currentStatementIndex.value,
          })
              }, [
                _createElementVNode("p", _hoisted_1, _toDisplayString(statement), 1),
                _cache[2] || (_cache[2] = _createElementVNode("span", { class: "onboarding-statements__quote iconfont iquote" }, null, -1))
              ], 6))
            }), 128))
          ]))
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          class: "onboarding-statements__button onboarding-statements__button--no",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (nextStatement(false)), ["prevent"]))
        }, [...(_cache[3] || (_cache[3] = [
          _createElementVNode("span", { class: "iconfont iclose-bold" }, null, -1),
          _createTextVNode(" No ", -1)
        ]))]),
        _createElementVNode("button", {
          class: "onboarding-statements__button onboarding-statements__button--yes",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (nextStatement(true)), ["prevent"]))
        }, [...(_cache[4] || (_cache[4] = [
          _createElementVNode("span", { class: "iconfont icheck-bold" }, null, -1),
          _createTextVNode(" Yes ", -1)
        ]))])
      ])
    ]),
    _: 1
  }, 8, ["title", "subtitle", "style"]))
}
}

})